// extracted by mini-css-extract-plugin
module.exports = {"placeholderHeight":"az_dU","categoryresultbottom":"az_eU","removeTopMargin":"az_fU"};